import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSavedFilterDataResponseClearById,
  setCurrentFilterView,
} from "../../redux/reports/actions";
import { reportButtonsArr, reportCategoryData } from "../../utils/testJson";
import ReportFilterModel from "../modal/ReportFilterModel";
import { useNavigate, useLocation } from "react-router-dom";
import CONFIG from "../../utils/config";
import { replace } from "lodash";

const ReportDashboardSection = (props) => {
  const { isMobile } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const userRole = useSelector((state) => state.user.role);
  const iframeRole = useSelector((state) => state.user.iframeRole);
  const authBroker = useSelector(state => state.auth.authBroker)
  const authIframeBroker = useSelector(state => state.auth.authIframeBroker)

  const [reportListing, setReportListing] = useState([]);
  const [defaultListing] = useState(reportCategoryData);
  const [show, setShow] = useState(false);
  const [showCompliance, setShowCompliance] = useState(false);
  const [heading, setHeading] = useState("Generate a Report");
  const [routeLink, setRouteLink] = useState("progress-report");
  const currentFilterView = useSelector(
    (state) => state.report.currentFilterView
  );

  const [currentReportObj, setCurrentReportObj] = useState(reportButtonsArr[0]);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(setCurrentFilterView(1));
  }, [dispatch]);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const filtersId = params.get("filters_id");
  const report_type = params.get("report_type");
  // const token = params.get("token");
  // const key = params.get("key");
  // const color_1 = params.get("color_1");
  // const color_2 = params.get("color_2");
  // const role = params.get("role");
  const fromdashboard = params.get("fromdashboard");
  const backbutton = params.get("backbutton");

  useEffect(() => {
    dispatch(getSavedFilterDataResponseClearById());
    localStorage.removeItem("SELECTED_FILTER");
  }, []);

  useEffect(() => {
    console.log("filters_id", filtersId, report_type);
    dispatch(getSavedFilterDataResponseClearById());
    if (filtersId && report_type) {
      console.log("filters_id", filtersId);
      if (isMobile) {
        // navigate(
        //   `${CONFIG.DOMAIN_URL}report-dashboard-mobile?token=${token}&key=${key}&color_1=${color_1}&color_2=${color_2}&role=${role}`,
        //   { replace: true }
        // );
      } else {
        navigate("/report", { replace: true });
      }
      switch (report_type) {
        case "compliance":
          console.log("compliance report", report_type);
          let complianceUrl = isMobile
            ? "/compliance-report-mobile"
            : "/compliance-report";
         
          navigate(JSON.parse(backbutton) ? `${complianceUrl}?filters_id=${filtersId}&backbutton=true` : `${complianceUrl}?filters_id=${filtersId}`);
          break;
        case "onboarding":
          let onboardingUrl = isMobile ? "/lp-report-mobile" : "/lp-report";
          console.log("onboarding report", report_type);
         
          navigate(JSON.parse(backbutton) ? `${onboardingUrl}?isCompliance=1&filters_id=${filtersId}&backbutton=true` : `${onboardingUrl}?isCompliance=1&filters_id=${filtersId}`);
          break;
        case "learning_path":
          let learningPathUrl = isMobile ? "/lp-report-mobile" : "/lp-report";
          console.log("learning path", report_type);
          navigate(JSON.parse(backbutton) ? `${learningPathUrl}?isCompliance=0&filters_id=${filtersId}&backbutton=true` : `${learningPathUrl}?isCompliance=0&filters_id=${filtersId}`);
          break;
        case "learning_progress":
          let learningProgressUrl = isMobile
            ? "/compliance-report-mobile"
            : "/compliance-report";
          console.log("learning progress report", report_type);
          navigate(
            JSON.parse(backbutton) ? `${learningProgressUrl}?isCompliance=0&filters_id=${filtersId}&backbutton=true`:  `${learningProgressUrl}?isCompliance=0&filters_id=${filtersId}`
          );
          break;
        case "code_of_ethics":
          let codeOfEthicsUrl = isMobile
            ? "/codeofethicsMobile-report"
            : "/codeofethics-report";
          console.log("code of ethics", report_type);
          navigate(JSON.parse(backbutton) ?`${codeOfEthicsUrl}?filters_id=${filtersId}&backbutton=true`: `${codeOfEthicsUrl}?filters_id=${filtersId}`);
          break;
        case "system_usage_report":
          let systemUsageUrl = isMobile
            ? "/systemusageMobile-report"
            : "/systemusage-report";
          console.log("system usage", report_type);
          navigate(JSON.parse(backbutton) ?`${systemUsageUrl}?filters_id=${filtersId}&backbutton=true` : `${systemUsageUrl}?filters_id=${filtersId}`);
          break;
          case "lp_survey_report":
            let lpSurveyUrl = isMobile
              ? "/learningpath-survey-report-mobile"
              : "/learningpath-survey-report";
            console.log("system usage", report_type);
            navigate(JSON.parse(backbutton) ?`${lpSurveyUrl}?filters_id=${filtersId}&backbutton=true&isCompliance=0&isLpSurvey=1` : `${lpSurveyUrl}?filters_id=${filtersId}&isCompliance=0&isLpSurvey=1`);
            break;
        default:
          break;
      }
    } else if (fromdashboard) {
      console.log("fromdashboard", fromdashboard, report_type);
      if (isMobile) {
        // navigate(
        //   `${CONFIG.DOMAIN_URL}report-dashboard-mobile?token=${token}&key=${key}&color_1=${color_1}&color_2=${color_2}&role=${role}`,
        //   { replace: true }
        // );
      } else {
        navigate("/report", { replace: true });
      }
      switch (report_type) {
        case "compliance":
          console.log("compliance report", report_type);
          let complianceUrl = isMobile
            ? "/compliance-report-mobile"
            : "/compliance-report";
          navigate(JSON.parse(backbutton) ? `${complianceUrl}?backbutton=true` :`${complianceUrl}`);
          break;
        case "onboarding":
          let onboardingUrl = isMobile ? "/lp-report-mobile" : "/lp-report";
          console.log("onboarding report", report_type);
          navigate(JSON.parse(backbutton) ? `${onboardingUrl}?isCompliance=1&backbutton=true` :`${onboardingUrl}?isCompliance=1`);
          break;
        default:
          break;
      }
    }
  }, [filtersId, report_type,fromdashboard]);

  useEffect(() => {
    if (isMobile) {
      if (iframeRole) {
        let newList = [];
        for (let list of defaultListing) {
          if (list.role.includes(iframeRole)) {
            newList.push(list);
          }
        }
        setReportListing(newList);
      }
    } else {
      if (userRole) {
        let newList = [];
        for (let list of defaultListing) {
          if (list.role.includes(userRole)) {
            newList.push(list);
          }
        }
        setReportListing(newList);
      }
    }
  }, [userRole, iframeRole, isMobile]);

  const renderTitle = () => {
    return (
      <>
        <div className="col-md-7">
          <h1 className="requesthead">Reports</h1>
          <p className="subhead">
            Generate, View and Download all types of Reports.
          </p>
        </div>
      </>
    );
  };

  useEffect(() => {
    if (showCompliance) {
      setHeading("Generate a Compliance Report");
    } else {
      setHeading("Generate a Report");
    }
  }, [showCompliance]);

  return (
    <>
      <section className="my-credit-points report-page">
        <div className="container">
          <div className="row">{renderTitle()}</div>
        </div>
        
        <div className="container">
          <div className="row g-5">
            <div className="col-md-12">
            </div>

            {reportButtonsArr?.map((item, index) => {
              // if (((authBroker.payload?.user?.is_corporate || 
              //   authIframeBroker.payload?.user?.is_corporate)) && item.id != 6
              // ) {
              //   return (
              //     <div className="col-md-6 col-lg-4 b" key={index}>
              //       <button
              //         className="report-g-btn btn-primary"
              //         onClick={() => {
              //           if (item.id === 4) {
              //             let routeLinkUrl = isMobile
              //               ? item.linkMobile
              //               : item.link;
              //             navigate(routeLinkUrl + "?isCompliance=" + 0);
              //           } else if (item.id === 2) {
              //             let routeLinkUrl = isMobile
              //               ? item.linkMobile
              //               : item.link;
              //             navigate(routeLinkUrl + "?isCompliance=" + 0);
              //           } else if (item.id === 1) {
              //             let routeLinkUrl = isMobile
              //               ? item.linkMobile
              //               : item.link;
              //             navigate(routeLinkUrl + "?isCompliance=" + 1);
              //           }
              //           // else if(item.id === 6)
              //           // {
              //           //   let routeLinkUrl = isMobile ? item.linkMobile : item.link
              //           //   navigate(routeLinkUrl);
              //           // }
              //           else {
              //             let routeLinkUrl = isMobile
              //               ? item.linkMobile
              //               : item.link;
              //             navigate(routeLinkUrl);
              //             // setShow(true);
              //             // dispatch(setCurrentFilterView(1))
              //             // setHeading(item.heading)
              //             // let routeLinkUrl = isMobile ? item.linkMobile : item.link
              //             // setRouteLink(routeLinkUrl)
              //             // setCurrentReportObj(item)
              //           }
              //         }}
              //       >
              //         {item.btnText}
              //       </button>
              //     </div>
              //   );
              // } else if (!(authBroker.payload?.user?.is_corporate || 
              //   authIframeBroker.payload?.user?.is_corporate)) {
              //   return (
              //     <div className="col-md-6 col-lg-4 b" key={index}>
              //       <button
              //         className="report-g-btn btn-primary"
              //         onClick={() => {
              //           if (item.id === 4) {
              //             let routeLinkUrl = isMobile
              //               ? item.linkMobile
              //               : item.link;
              //             navigate(routeLinkUrl + "?isCompliance=" + 0);
              //           } else if (item.id === 2) {
              //             let routeLinkUrl = isMobile
              //               ? item.linkMobile
              //               : item.link;
              //             navigate(routeLinkUrl + "?isCompliance=" + 0);
              //           } else if (item.id === 1) {
              //             let routeLinkUrl = isMobile
              //               ? item.linkMobile
              //               : item.link;
              //             navigate(routeLinkUrl + "?isCompliance=" + 1);
              //           }
              //           // else if(item.id === 6)
              //           // {
              //           //   let routeLinkUrl = isMobile ? item.linkMobile : item.link
              //           //   navigate(routeLinkUrl);
              //           // }
              //           else {
              //             let routeLinkUrl = isMobile
              //               ? item.linkMobile
              //               : item.link;
              //             navigate(routeLinkUrl);
              //             // setShow(true);
              //             // dispatch(setCurrentFilterView(1))
              //             // setHeading(item.heading)
              //             // let routeLinkUrl = isMobile ? item.linkMobile : item.link
              //             // setRouteLink(routeLinkUrl)
              //             // setCurrentReportObj(item)
              //           }
              //         }}
              //       >
              //         {item.btnText}
              //       </button>
              //     </div>
              //   );
              // }
              return (
                <div className="col-md-6 col-lg-4 b" key={index}>
                  <button
                    className="report-g-btn btn-primary"
                    onClick={() => {
                      if (item.id === 4) {
                        let routeLinkUrl = isMobile
                          ? item.linkMobile
                          : item.link;
                        navigate(routeLinkUrl + "?isCompliance=" + 0);
                      } else if (item.id === 2) {
                        let routeLinkUrl = isMobile
                          ? item.linkMobile
                          : item.link;
                        navigate(routeLinkUrl + "?isCompliance=" + 0);
                      } else if (item.id === 1) {
                        let routeLinkUrl = isMobile
                          ? item.linkMobile
                          : item.link;
                        navigate(routeLinkUrl + "?isCompliance=" + 1);
                      } else if(item.id === 7) {
                        let routeLinkUrl = isMobile
                          ? item.linkMobile
                          : item.link;
                        navigate(routeLinkUrl + "?isCompliance=" + 0 +"&isLpSurvey="+1);
                      }
                      // else if(item.id === 6)
                      // {
                      //   let routeLinkUrl = isMobile ? item.linkMobile : item.link
                      //   navigate(routeLinkUrl);
                      // }
                      else {
                        let routeLinkUrl = isMobile
                          ? item.linkMobile
                          : item.link;
                        navigate(routeLinkUrl);
                        // setShow(true);
                        // dispatch(setCurrentFilterView(1))
                        // setHeading(item.heading)
                        // let routeLinkUrl = isMobile ? item.linkMobile : item.link
                        // setRouteLink(routeLinkUrl)
                        // setCurrentReportObj(item)
                      }
                    }}
                  >
                    {item.btnText}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <ReportFilterModel
        show={show}
        setShow={setShow}
        heading={heading}
        showCompliance={showCompliance}
        routeLink={routeLink}
        currentReportObj={currentReportObj}
        isMobile={isMobile}
      />
    </>
  );
};
export default ReportDashboardSection;
